module.exports = __webpack_public_path__ + "78af3a6954f9eb3b3af8d99adae1d5e8.svg";